import OtherDocuments from './OtherDocuments';

export default OtherDocuments;
